<template>
  <v-text-field
    :label="field.name"
    :rules="fieldRules"
    :model-value="modelValue"
    :hint="field.description"
    @update:model-value="onInput"></v-text-field>
</template>
<script setup lang="ts">
import { RubricFieldDTO, IRubricFieldDTO, RubricFieldTypeEnum } from '@/dtos';
import { rules } from '@/helpers';

import { ref, watch } from 'vue';

const props = defineProps<{
  field: IRubricFieldDTO;
  modelValue?: string;
}>();
const field = ref<IRubricFieldDTO>(new RubricFieldDTO());

const fieldRules = ref<((value: string) => true | string)[]>([]);

const emit = defineEmits<{
  (e: 'update:modelValue', fieldId: string, value: string): void;
}>();

const onInput = (value: string) => {
  emit('update:modelValue', field.value.id, value);
};

watch(
  () => props.field,
  () => {
    fieldRules.value = [];
    if (props.field) {
      field.value = new RubricFieldDTO(props.field);
    } else {
      field.value = new RubricFieldDTO();
    }

    if (field.value.is_required) {
      fieldRules.value.push(rules.required);
    }

    if (field.value.type == RubricFieldTypeEnum.Number) {
      fieldRules.value.push(rules.numeric);
    }
  },
  { immediate: true },
);
</script>
